var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-input',{attrs:{"autofocus":"","placeholder":"Wpisz fragment nazwy szukanego produktu","prefix-icon":"el-icon-search","type":"text","clearable":true},model:{value:(_vm.q),callback:function ($$v) {_vm.q=$$v},expression:"q"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117e6c6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-box.vue
// module id = BY43
// module chunks = 1